<template>
  <div class="documenso-container">
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>Conectando...</p>
    </div>
    <iframe v-if="documentUrl" :src="documentUrl" class="documenso-iframe" frameborder="0" allow="clipboard-write"
      allowfullscreen></iframe>
  </div>
</template>

<script>
import PocketBase from "pocketbase";
const pb = new PocketBase("https://pocketbase.jdza.site");

export default {
  name: "DocumensoEmbed",
  data() {
    return {
      documentUrl: null,
      loading: true,
      unsubscribe: null,
    };
  },
  // async created() {
  //   await pb.realtime.subscribe("documenso", (e) => {
  //     console.log("PocketBase Realtime Event:", e);
  //     // Filtrar solo los registros cuyo campo "token" coincida
  //     // if (e.record.token === token) {
  //     //   console.log("=== PocketBase Realtime Event Recibido ===");
  //     //   console.log("Action:", e.action);
  //     //   console.log("Record ID:", e.record.id);
  //     //   console.log("Record token:", e.record.token);
  //     //   console.log("Record completo:", e.record);
  //     //   console.log("==========================================");
  //     // }
  //   });
  // },
  async mounted() {
    await this.initializeDocument();
    await this.subscribeToRealtime();
  },
  beforeDestroy() {
    // Cancelar la suscripción al destruir el componente
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    async initializeDocument() {
      // Obtener el token del documento desde los parámetros de la ruta
      const token = this.$route.params.token;
      if (token) {
        this.documentUrl = `https://app.documenso.com/sign/${token}`;
      } else {
        // URL por defecto si no hay token
        this.documentUrl = "https://app.documenso.com/sign/Hso-zmWcGqL6cMSwLi_uF";
      }
      this.loading = false;
    },
    async subscribeToRealtime() {
      const token = this.$route.params.token;

      if (!token) {
        console.log("No hay token, no se suscribirá a PocketBase");
        return;
      }

      console.log("Intentando suscribirse a registros con token:", token);

      try {
        // Suscribirse a toda la colección y filtrar por el campo "token"
        this.unsubscribe = await pb.collection("documenso").subscribe("*", (e) => {
          console.log("PocketBase Realtime Event:", e);
          // Filtrar solo los registros cuyo campo "token" coincida
          if (e.record.token === token) {
            console.log("=== PocketBase Realtime Event Recibido ===");
            console.log("Action:", e.action);
            console.log("Record ID:", e.record.id);
            console.log("Record token:", e.record.token);
            console.log("Record completo:", e.record);
            console.log("==========================================");
            // Redirigir a Stripe
            window.location.href = "https://stripe.com";
          }
        });
        console.log("Suscrito exitosamente a PocketBase - Colección: documenso, filtrando por token:", token);
      } catch (error) {
        console.error("Error al suscribirse a PocketBase:", error);
      }
    },
  },
};
</script>

<style scoped>
.documenso-container {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
}

.documenso-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  z-index: 10;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-overlay p {
  margin-top: 15px;
  color: #666;
  font-family: Arial, sans-serif;
}
</style>
